function getBaseFileName(imagePath) {
    if (!hasExtension(imagePath)) {
        return imagePath;
    }
    var parts = imagePath.split('.');
    if (parts.length > 1) {
        parts.pop();
        return parts.join('.');
    }
    else {
        return imagePath;
    }
}
function hasExtension(imagePath) {
    return /\.[a-z]+$/.test(imagePath);
}

export { getBaseFileName, hasExtension };
